export default __webpack_public_path__ + "static/media/whyHyperMobile.63145505.svg";